// Builder element trees used as `defaultValue` for the accordion authoring
// inputs. Ported 1:1 from hec-composable
// (hec/builder/blocks/accordion/defaultConfig.js) so a freshly-inserted
// accordion in the Builder editor matches the legacy starting content.

export const defaultTitle = {
  "@type": "@builder.io/sdk:Element" as const,
  layerName: "Accordion Title",
  responsiveStyles: {
    large: {
      marginTop: "10px",
      position: "relative",
      display: "flex",
      alignItems: "stretch",
      paddingTop: "10px",
      paddingBottom: "10px",
    },
  },
  component: {
    name: "AccordionTitle",
    options: {
      content: [
        {
          "@type": "@builder.io/sdk:Element" as const,
          responsiveStyles: {
            large: {
              textAlign: "left",
              display: "flex",
            },
          },
          component: {
            name: "Text",
            options: {
              text: "I am an accordion title. Click me!",
            },
          },
        },
      ],
    },
  },
};

export const defaultDetail = {
  "@type": "@builder.io/sdk:Element" as const,
  layerName: "Accordion Detail",
  responsiveStyles: {
    large: {
      marginTop: "10px",
      position: "relative",
      display: "flex",
      alignItems: "stretch",
      flexDirection: "column",
      paddingTop: "10px",
      paddingBottom: "10px",
    },
  },
  component: {
    name: "AccordionDetail",
    options: {
      content: [
        {
          "@type": "@builder.io/sdk:Element" as const,
          responsiveStyles: {
            large: {
              textAlign: "left",
              display: "flex",
              flexDirection: "column",
            },
          },
          component: {
            name: "Text",
            options: {
              text: "I am accordion content!!!",
            },
          },
        },
      ],
    },
  },
};

export const defaultItem = {
  "@type": "@builder.io/sdk:Element" as const,
  layerName: "Accordion Item",
  responsiveStyles: {
    large: {
      marginTop: "10px",
      position: "relative",
      display: "flex",
      alignItems: "stretch",
      flexDirection: "column",
    },
  },
  component: {
    name: "AccordionItem",
    options: {
      content: [defaultTitle, defaultDetail],
    },
  },
};
